import { Component, OnInit, ViewChild, Inject, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { DenunciaService } from 'src/app/service/denuncia/denuncia.service';
import { OK_MANIFESTO_ENVIADO, ERRO_DADOS_NAO_GRAVADOS, ERRO_DADOS_OBRIGATORIOS, ERRO_ASSUNTO_OBRIGATORIO, MSG_POPUP_CONFIRMACAO_DENUNCIA } from 'src/app/tools/Mensagens';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { DenunciaVO } from 'src/app/entity/DenunciaVO';
import { AbstractControl, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmWindowComponent } from 'src/app/componentes/confirm-window/confirm-window.component';


@Component({
  selector: 'denuncia',
  templateUrl: './denuncia.component.html',
  styleUrls: ['./denuncia.component.css']
})
export class DenunciaComponent implements OnInit {
  anonimoMarcado: Boolean = false;
  formSubmitted: boolean = false;
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  modalRef: BsModalRef;
  message: string;
  mensagemPopUpDenuncia = MSG_POPUP_CONFIRMACAO_DENUNCIA;
  camposNaoPreenchidos: String = "";

  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL = 52;
  CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR = 53;
  CLASSIFICACAO_SERVIDOR_INTERIOR = 60;

  constructor(
    public service: DenunciaService,
    public authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    public modalService: BsModalService
    ) {
  }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      this.service.denuncia.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.denuncia.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.denuncia.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.denuncia.controls.listaUnidade.setValue(retorno.listaUnidade);
        this.service.denuncia.controls.assuntos.setValue(retorno.assuntos);
        this.service.denuncia.controls.listaMunicipio.setValue(retorno.listaMunicipio);
        this.service.denuncia.controls.listaComarcas.setValue(retorno.listaComarcas);
        //this.service.denuncia.controls.listaOrigemNotificacaoCompleta.setValue(retorno.listaOrigemNotificacaoCompleta);
        this.service.denuncia.controls.listaOrigemNotificacaoPublicoExterno.setValue(retorno.listaOrigemNotificacaoPublicoExterno);
        this.service.denuncia.controls.listaOrigemNotificacaoPublicoInterno.setValue(retorno.listaOrigemNotificacaoPublicoInterno);
        this.service.denuncia.controls.listaOrgaoVinculadoAgressoresCompleta.setValue(retorno.listaOrgaoVinculadoAgressoresCompleta);

        this.checarAssuntoUnico();
      }
    });
  }

  checarAssuntoUnico() {
    if (this.service.denuncia.controls.assuntos.value != null && this.service.denuncia.controls.assuntos.value.length == 1) {
      this.changeAssunto(this.service.denuncia.controls.assuntos.value[0]);
    }
  }

  alterarStatusAnonimo() {
    this.anonimoMarcado = !this.anonimoMarcado;
    this.service.denuncia.value.anonimo = this.anonimoMarcado;
  }

  resetForm() {
    this.service.denuncia.reset();
  }


  montarPayload(): any {
    const formulario = this.service.denuncia.getRawValue();
    return this.service.criarEstruturaTipoDetalhe(formulario);
  }

// Getter para acessar o FormGroup de infância
  get infanciaGroup(): FormGroup {
    return this.service.denuncia.get('infancia') as FormGroup;
  }


  onSubmit() {
    this.formSubmitted = true;
    try { this.service.denuncia.markAllAsTouched(); } catch (e) { /* noop */ }

    if (this.service.denuncia.value.assunto) {
      this.montarPayload();
      this.preencherDados();
      if (this.service.denuncia.valid) {
        this.service.enviar(this.service.denuncia.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        const campos = this.tratarMensagemDeErro();
        alert(ERRO_DADOS_OBRIGATORIOS + campos);
      }
    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  isValidoRegrasDenuncia() {
    var mensagemErro = this.service.validaCamposDenunciaService(this.service.denuncia);

    if(mensagemErro.length > 0){
      //alert(mensagemErro);
      this.camposNaoPreenchidos = mensagemErro;
      return false;
    }

    return true;
  }

  preencherDados() {
    this.service.denuncia.controls.nome.setValue(this.authService.usuarioDTO.nome);
    this.service.denuncia.controls.email.setValue(this.authService.usuarioDTO.email);
    this.service.denuncia.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.denuncia.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let construtor: any = DenunciaVO.prototype.constructor;
    Object.values(this.service.denuncia.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push('\n' + construtor.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  changeAssunto(item) {
    this.service.denuncia.controls.assunto.setValue(item);
  }

  isChecked(item) {
    return this.service.denuncia.controls.assunto.value == item;
  }

  // Método que realiza a abertura do modal, caso as validações sejam aceitas. Caso contrário, será apresentado apenas mensagem de erro.
  openModalPopUp(template: TemplateRef<any>) {
    //this.openDialog();
    this.formSubmitted = true;
    try { this.service.denuncia.markAllAsTouched(); } catch (e) { /* noop */ }

    if (this.service.denuncia.value.assunto) {
      this.preencherDados();

      if (this.isValidoRegrasDenuncia()) {
        // Chamada usando o proprio componente - ERRRO - Não esta identificando o template
        //this.modalRef = this.modalService.show(ConfirmWindowComponent, {class: 'modal-sm'});
        // Chamada usando o componente já estabelecido no denuncia.component.html (OK)
        this.modalRef = this.modalService.show(template, {class: 'modal-sm'});

      } else {

        // Utilizando solução das validações sendo passadas para o service, não há a necessidade de atribuir mensagens de erros mais desta forma pois a mensagem de erro será
        // passada na propria validação.
        // TODO Verificar se o código precisará ser retirado.

        //const campos = this.tratarMensagemDeErro();
        //campos.push(this.camposNaoPreenchidos);
        //this.camposNaoPreenchidos = "";
        //alert(ERRO_DADOS_OBRIGATORIOS + campos);

        //alert(ERRO_DADOS_OBRIGATORIOS + '\n' + this.camposNaoPreenchidos);
        alert(this.camposNaoPreenchidos);
      }

    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  confirm(): void {
    // Deverá ser executada toda a lógica de envio da denúncia
    this.onSubmit();

    this.modalRef.hide();
  }

  decline(): void {
    //this.message = 'Cancelado';
    this.modalRef.hide();
  }

  // TODO Verificar se deverão ser retirados
  // Método antigo de validação de campos (OS 1202 - Verificar se deverá ser retirado)
  isValidoRegrasDenunciaAntigo() {
    var retorno = true;

    // Caso não seja dado legado, será tratado pela única classificação que existirá.
    if (this.service.denuncia.value.listaClassificacao.length == 1) {
      var idClassificacao = this.service.denuncia.value.listaClassificacao[0].id;
      this.tratarMensagensErroCamposClassificacao(idClassificacao);
      retorno = this.camposNaoPreenchidos != "" ? false : true;
    }

    if (!this.service.denuncia.valid) {
      retorno = false;
    }

    return retorno;

  }

  // Tratamento antigo de mensagens (OS 1202 - Verificar se deverá ser retirado)
  tratarMensagensErroCamposClassificacao(idClassificacao: any) {

    // Campos de Cartórios Extrajudiciais Capital
    if (idClassificacao === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_CAPITAL) {

      if (this.service.denuncia.value.codigoCNS == null || this.service.denuncia.value.codigoCNS == '') {
        this.camposNaoPreenchidos += "\n Nome do Cartório";
      }

      if (this.service.denuncia.value.localidade == '') {
        this.camposNaoPreenchidos += ",\n Localidade";
      }

      // Campos de Cartórios Extrajudiciais Interior
    } else if (idClassificacao === this.CLASSIFICACAO_CARTORIO_EXTRAJUDICIAL_INTERIOR) {

      if (this.service.denuncia.value.codigoMunicipio == null || this.service.denuncia.value.codigoMunicipio == '') {
        this.camposNaoPreenchidos += "\n Municipio";
      }

      if (this.service.denuncia.value.codigoCNS == null || this.service.denuncia.value.codigoCNS == '') {
        this.camposNaoPreenchidos += ",\n Nome do Cartório";
      }

      if (this.service.denuncia.value.localidade == '') {
        this.camposNaoPreenchidos += ",\n Localidade";
      }

      // Campos de Servidor Interior
    } else if (idClassificacao === this.CLASSIFICACAO_SERVIDOR_INTERIOR) {

      if (this.service.denuncia.value.codigoMunicipio == null || this.service.denuncia.value.codigoMunicipio == '') {
        this.camposNaoPreenchidos += "\n Comarca";
      }
    }
  }


}
